module.exports = __webpack_public_path__ + "static/media/openEmail.82754465.svg";